import React from 'react'

export const BackgroundDesktop = () => (
  <div className='relative'>
    <div className='absolute left-[0px] top-[1465px]   w-[412px] h-[444px] bg-[#eaeaff] bg-opacity-60  rounded-full blur-[300px]' />
    <div className='absolute left-[874px] top-[1227px] w-[488px] h-[553px] bg-[#65c2d7] bg-opacity-30 rounded-full blur-[700px]' />
    <div className='absolute left-[1249px] top-[672px] w-[616px] h-[1213px] bg-[#9abceb] bg-opacity-40 rounded-full blur-[500px]' />
    <div className='absolute left-[1508px] top-[0px]   w-[412px] h-[444px] bg-[#e3fffb] bg-opacity-60 rounded-full blur-[400px]' />
  </div>
)

export const BackgroundMobile = () => (
  <div className='absolute w-[360px] h-[517px] top-[25px]'>
    <div className='absolute w-[94px] h-[272px] left-0 top-0 bg-[#65c2d7] rounded-full blur-[150px]' />
    <div className='absolute w-[80px] h-[365px] left-[280px] top-[152px] bg-[#9abceb] rounded-full blur-[200px]' />
  </div>
)
